export default __webpack_public_path__ + "static/media/placeholder_business02-fr-web.c8674573.png";